const zh: Record<string, string> = {
  "site.name": "开云体育",
  "site.slogan": "官方正品体育平台",
  "site.description": "领先的综合体育平台，提供丰富的体育赛事资讯、赛事直播、体育竞技数据及专业服务",
  "nav.home": "首页",
  "nav.categories": "赛事分类",
  "nav.about": "关于我们",
  "nav.login": "登录",
  "nav.register": "注册",
  "home.hero.title": "畅享全球顶级体育赛事",
  "home.hero.subtitle": "开云体育汇聚全球赛事资讯、实时直播与专业数据，为您带来极致的体育体验",
  "home.hero.cta": "立即加入",
  "home.hero.secondary": "了解更多",
  "home.categories.title": "热门赛事分类",
  "home.categories.subtitle": "覆盖全球主流体育项目，一站式获取所有赛事信息",
  "home.live.title": "正在直播",
  "home.live.subtitle": "实时赛事直播，不错过每一场精彩对决",
  "home.live.watch": "观看直播",
  "home.articles.title": "最新体育资讯",
  "home.articles.subtitle": "掌握全球体育动态，深度解读赛事背后的故事",
  "home.articles.readmore": "阅读全文",
  "home.faq.title": "常见问题",
  "home.faq.subtitle": "快速了解开云体育平台",
  "category.all": "全部",
  "category.football": "足球",
  "category.basketball": "篮球",
  "category.tennis": "网球",
  "category.esports": "电竞",
  "category.comprehensive": "综合体育",
  "breadcrumb.home": "首页",
  "article.related": "相关文章",
  "article.back": "返回列表",
  "article.published": "发布时间",
  "article.author": "作者",
  "article.source": "来源",
  "about.title": "关于开云体育",
  "about.intro": "品牌介绍",
  "about.reputation": "品牌信誉",
  "about.contact": "联系我们",
  "about.vision": "品牌愿景",
  "footer.copyright": "© 2026 开云体育 版权所有",
  "footer.terms": "服务条款",
  "footer.privacy": "隐私政策",
  "footer.contact": "联系我们",
  "footer.disclaimer": "开云体育致力于为用户提供优质的体育资讯服务，所有内容仅供参考。",
};

export default zh;